import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import getCookie from '../Queries/getCookie';

// Components
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '../Alert';

// Queries
import getLogin from '../Queries/getLogin.js';
import postGlobal from '../Queries/postGlobal.js';

// Styles
import styles from './index.module.sass';

// Images
import WATERMARK from '../../images/sign/terramar-letras-marca-de-agua.png';

export default function LoginForm({ history, screenSize }) {
  const [open, setOpen] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [loginResponse, setLoginResponse] = useState({});
  const [alertText, setAlertText] = useState('');
  const [errorsArr, setErrorsArr] = useState([]);
  const [form, setForm] = useState({ kitname: '', kitpassword: '' });
  const [loading, setLoading] = useState(false);
  const [nextRoute, setNextRoute] = useState('');
  const { t } = useTranslation('sign');

  const handleChange = (e, type) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
    setErrorsArr([]);
  };

  function handelDialog(action, messaje, route) {
    if (messaje) setAlertText(messaje);
    setOpen(action);
    if (route) setNextRoute(route);
    if (!action && nextRoute) history.push(nextRoute);
  }

  const manageLogin = useCallback(
    (response) => {
      const { usuario = '', nombre = '', token = '' } = response;

      const now = new Date();
      const time = now.getTime();
      const expireTime = time + 1000 * 36000;
      now.setTime(expireTime);
      document.cookie = `usuarioOk=${usuario
        .toUpperCase()
        .replace('TE', '')
        .replace('TM', '')};expires=${now.toUTCString()};path=/`;
      document.cookie = `usuario=${usuario.toUpperCase()};expires=${now.toUTCString()};path=/`;
      document.cookie = `kitName=${nombre};expires=${now.toUTCString()};path=/`;
      document.cookie = `TMBcartToken=${token};expires=${now.toUTCString()};path=/`;
      window.gtag('event', 'login', {
        method: 'getLogin',
      });
      setLoading(false);
      history.push('/cart/consultancy/home/');
    },
    [history],
  );

  const handelTermsDialog = useCallback(async () => {
    setLoading(true);
    const resp = await postGlobal({
      tmbservice: 'aceptoTerminos',
      token: loginResponse.token,
      jsonBody: {},
    });

    if (resp.typeMessage !== 'success') {
      setOpen(true);
      setAlertText(t('policiesError'));
      setLoading(false);
      return;
    }

    manageLogin(loginResponse);
  }, [loginResponse, manageLogin, t]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (
      getCookie(`cartCookie${process.env.REACT_APP_COUNTRY}`) ||
      getCookie(`cartCookie${process.env.REACT_APP_COUNTRY}`) === 'accepted'
    ) {
      setLoading(true);

      const response = await getLogin({ form });
      if (response.tipoMensaje === 'exito') {
        setLoginResponse(response);
        const { terminosAceptados = false } = response;

        if (!terminosAceptados) {
          setOpenTerms(true);
          setLoading(false);
          return;
        }
        manageLogin(response);
      } else {
        setLoading(false);
        setAlertText(t('loginFailed'));
        setOpen(true);
        return;
      }
    } else {
      setAlertText(t('acceptcks'));
      setOpen(true);
    }
  }

  return (
    <form
      className={`${styles.formContainer} ${styles[screenSize]}`}
      style={{
        backgroundImage: `url(${WATERMARK})`,
      }}>
      <Alert
        open={openTerms}
        setOpen={setOpenTerms}
        title={t('policiesChangedTittle')}
        cancel={true}
        text={
          <div>
            <div className={styles.policiesText}>{t('policiesChangedText')}</div>
            <div className={styles.policiesText}>{t('policiesChangedText2')}</div>
            <div>
              <a
                className={styles.policiesLink}
                href='https://www.terramarbrandsusa.com/legal/policesAndProcedures_us'
                target='_blank'
                rel='noreferrer'>
                {t('policiesChangedLink')}
              </a>
            </div>
            <div>
              <a
                className={styles.policiesLink}
                href='https://www.terramarbrandsusa.com/legal/agreement_us'
                target='_blank'
                rel='noreferrer'>
                {t('policiesChangedLink2')}
              </a>
            </div>
          </div>
        }
        callback={() => handelTermsDialog(false)}
      />
      <Alert
        open={open}
        setOpen={setOpen}
        title={'Terramar'}
        text={alertText}
        callback={() => handelDialog(false)}
      />
      <div className={styles.formContent}>
        <div className={styles.error}>
          {errorsArr.map((error, key) => {
            return <div key={key}>{error.message}</div>;
          })}
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.inputLabel}>{t('kitTitle')}</div>
          <input
            type='text'
            className={styles.inputText}
            name='kitname'
            value={form.kitname}
            onChange={(e) => handleChange(e)}
          />
        </div>
        <div className={styles.inputContainer}>
          <div className={styles.inputLabel}>{t('passwordTitle')}</div>
          <input
            className={styles.inputText}
            type='password'
            name='kitpassword'
            maxLength='10'
            value={form.kitpassword}
            onChange={(e) => handleChange(e)}
          />
        </div>
        <Button
          type='submit'
          variant='contained'
          size='large'
          color='primary'
          className={styles.button}
          onClick={(e) => {
            if (loading) return;

            handleSubmit(e);
          }}>
          {(loading && <CircularProgress className={styles.circularProgress} />) || t('textButton')}
        </Button>
        <div className={styles.forgotPassword} onClick={() => history.push('/forgotPassword')}>
          {t('forgotPassword')}
        </div>
        {process.env.REACT_APP_COUNTRY === 'US' && (
          <div className={styles.notAccount}>
            <span>{t('notAccount1')}</span>{' '}
            <span
              className={styles.clickHere}
              onClick={() => history.push('/contractus/newcontractus')}>
              {t('notAccount2')}
            </span>
          </div>
        )}
      </div>
    </form>
  );
}
